// extracted by mini-css-extract-plugin
export default {"TimeSlotWrapper":"timeSlot_TimeSlotWrapper_LmIHJ","TimeSlotContent":"timeSlot_TimeSlotContent_Cl82b"};